import Sidebar from './Sidebar.jsx';
import BottomTabBar from './BottomTabBar.jsx';
import EntitySelector from './EntitySelector.jsx';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-slate-50 flex">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        {/* Mobile-only header with entity selector — desktop has it in sidebar. */}
        <header className="lg:hidden sticky top-0 z-10 bg-white">
          <EntitySelector />
        </header>
        <main className="flex-1 min-w-0 pb-20 lg:pb-6 px-4 py-4 md:px-6 lg:px-8">
          {children}
        </main>
      </div>
      <BottomTabBar />
    </div>
  );
}
